import { IqueryParams, IUserCategory } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

type UserCategory = {
  name: string;
};
const createUserCategory = async (data: UserCategory) => {
  return apiService.apiRequest<IUserCategory>(
    "post",
    `user-categories`,
    data
  );
};
const getUserCategories = async (queryParams?:IqueryParams< {
  user_category_name?:string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<IUserCategory[]>("get", `user-categories${query}`);
};

const getUserCategoryById  = async (
  user_category_id: string,
) => {
  return apiService.apiRequest<IUserCategory>(
    "get",
    `user-categories/${user_category_id}`
  );
};

const updateUserCategory = async (
  user_category_id: string,
  data: UserCategory
) => {
  return apiService.apiRequest<IUserCategory>(
    "put",
    `user-categories/${user_category_id}`,
    data
  );
};
const deleteUserCategory = async (user_category_id: string) => {
  return apiService.apiRequest<any>(
    "delete",
    `user-categories/${user_category_id}`
  );
};

const restoreUserCategory = async (user_category_id: string) => {
  return apiService.apiRequest<any>(
    "get",
    `user-categories/${user_category_id}/restore`
  );
};

export const userCategoryApi = {
  createUserCategory,
  getUserCategories,
  updateUserCategory,
  deleteUserCategory,
  restoreUserCategory,
  getUserCategoryById
};
